export const NAME_LOGIN = 'Login'
export const NAME_RESET_PASSWORD = 'Reset Password'
export const NAME_SOCIAL_MONITOR = 'Social Monitor'
export const NAME_VERBATIM_MANAGEMENT = 'Verbatim Management'
export const NAME_KEYWORD_MANAGEMENT = 'Keyword Management'
// export const NAME_NEW_AGGREGATION = 'Add New Aggregation'
export const NAME_NEW_AGGREGATION = 'Add New Item'
export const NAME_QUESTION_MANAGEMENT = 'Question Management'
export const NAME_SUB_QUESTION_MANAGEMENT = 'Sub Question Management'
export const NAME_USER_MANAGEMENT = 'User Management'
// export const NAME_USER_MANAGEMENT_ACCESS = 'User Management Access'
// export const NAME_USER_MANAGEMENT_SIGNUP = 'User Management Signup'
export const NAME_ADMIN_TOOL = 'Project Management'
